import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
import { FeatureEntitlements } from './featureEntitlements'

export const sfpCampaignAndSegmentAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess],
    featureEntitlementIds: [FeatureEntitlements.MultiBannerSfpCampaignAndSegment],
  },
  {
    warehouseFeatureToggles: [FeatureToggle.wholesalerCampaignsEnabled],
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
    ],
    notFeatureToggles: [FeatureToggle.retailerFundedMarketingUserDenyList],
    minICPlatformVersion: ICPlatformVersion.r2025_11_0,
    featureEntitlementIds: [FeatureEntitlements.MultiBannerSfpCampaignAndSegment],
  },
]
